import {PlaceOrderRequest} from "./placeOrderRequest";
import ActivityCartItem from "../../swiss_ui/cart/ActivityCartItem";
import {SERVICE_CATEGORIES} from "../../../adlevo-vue/appConfiguration";
import {parseDateInYYY_MM_DD} from "../../../adlevo-vue/utils/dateFormator";
import { getCurrency } from '../../../utils/localization';

export class PlaceOrderWithoutGuestsRequest extends PlaceOrderRequest {


    /**
     * @todo: Integrate new options here.
     * @return {{bookings: {}}}
     */
    buildRequest() {

        const self = this;

        // console.log('placeOrder buildRequest');
        // here items means cart items objects
        // console.log(this.handler.items);
        // console.log(self);

        let tourBookings = {}

        let hotelBookings = {
            items: [],
            leader: self.getLeaderRequest()
        }

        $.each(self.handler.items, function (ix, cartItem) {
            switch (cartItem.getType()) {
                case SERVICE_CATEGORIES.ACTIVITIES: {
                    const tourCartItem = cartItem;
                    const tourId = tourCartItem.tour.id
                    if (tourCartItem.status) {
                        tourBookings[tourId] = {
                            ...tourCartItem,
                            ...tourCartItem.request, // move guests (adults, children) to root object.
                            tour_id: tourId,
                            // tour_option_id: tourOptionId,
                            // tour_option: selectedTourOption,
                            pickup_option: null,
                            guests: null,
                            leader: self.getLeaderRequest()
                        }

                        if (!!tourCartItem.request.infants) {
                            tourBookings[tourId].infants = tourCartItem.request.infants;
                        }
                    }

                    break;
                }
                case SERVICE_CATEGORIES.HOTELS: {
                    const hotelCartItem = cartItem;
                    hotelCartItem.rooms.forEach((room) => {

                        room.availability.forEach(roomAvailability => {
                           hotelBookings.items.push({
                               hotel_id: hotelCartItem.id,
                               start_date: parseDateInYYY_MM_DD(room.checkInDate),
                               end_date: parseDateInYYY_MM_DD(room.checkOutDate),
                               num_of_adults: roomAvailability.num_of_adults,
                               num_of_children: roomAvailability.num_of_children,
                               num_of_allotment: roomAvailability.num_of_allotment,
                               children_ages: roomAvailability.children_ages,
                               room_type_id: room.roomTypeId,
                               price: room.total_price,
                               channel_manager_id: Number(room.channel_manager_id),
                               currency_type: room.currency_type ? room.currency_type : getCurrency(),
                               hotel_code: room.hotel_code ? room.hotel_code : '',
                               reserved_product_code: room.reserved_product_code ? room.reserved_product_code : null,
                               room_code: room.room_code ? room.room_code : null,
                               rate_plan_code: room.rate_plan_code ? room.rate_plan_code : null,
                               rate_plan_id: room.rate_plan_id ? room.rate_plan_id : 0,
                           })
                        });
                    })

                    break;
                }
            }
        });

        const request = {
            bookings: {
                tours: tourBookings,
                hotels: hotelBookings
            }
        }


        /**
         * Fill payments array
         */
        request.payment = this.handler.getPaymentRequest();

        // console.log('finale request is here');
        // console.log(request);

        return request;
    }

    /**
     * Get leader
     * @return {{name: (jQuery|string|undefined), phonenumber: (jQuery|string|undefined), email: (jQuery|string|undefined)}}
     */
    getLeaderRequest() {
        return {
            // full_name: $(this.handler.selectors.payment.payer.name).val(),
            first_name: $(this.handler.selectors.payment.payer.first_name).val(),
            last_name: $(this.handler.selectors.payment.payer.last_name).val(),
            email: $(this.handler.selectors.payment.payer.email).val(),
            phonenumber: $(this.handler.selectors.payment.payer.phonenumber).val(),
            area_code: document.querySelector('.iti__selected-dial-code').innerHTML
        };
    }
}